export abstract class Model {
  constructor(public accessPermission: number) {}
  public abstract or(this: Model, obj: Model);
  public abstract get className(): string;
}
